// The firm-wide Drive import, in the same dialog as the ids that decide what
// it can reach. One pass over the least recently read case folders; the
// counters are the server's own, so they survive this dialog closing.

import { useDriveImportRun, useStartDriveImportRun } from "../../hooks/useDriveImportRun";

const MAX_CASES = 10;

export function DriveImportSection() {
  const runQ = useDriveImportRun(true);
  const start = useStartDriveImportRun();
  const run = runQ.data;

  // A process that has never run holds zeros, and calling that "last run: 0
  // files" would invent a run nobody started.
  const ran =
    run &&
    (run.running ||
      run.casesLooked > 0 ||
      run.filesImported > 0 ||
      run.documentsExtracted > 0 ||
      run.clientsLinked > 0);

  return (
    <section className="settings-section">
      <h3>Documents from Drive</h3>
      <p className="settings-sub">
        Reads the {MAX_CASES} case folders checked longest ago and pulls in what the matter does not
        already hold. Google Docs and files over 10 MB stay where they are.
      </p>

      <div className="settings-actions">
        <button
          type="button"
          className="settings-save-btn"
          disabled={Boolean(run?.running) || start.isPending}
          onClick={() => start.mutate(MAX_CASES)}
        >
          {run?.running ? "Import running..." : "Import documents now"}
        </button>
      </div>

      {ran && (
        <p className="settings-hint" role="status">
          {run.running ? "Running" : "Last run"}: {run.casesLooked} folder
          {run.casesLooked === 1 ? "" : "s"} read, {run.filesImported} file
          {run.filesImported === 1 ? "" : "s"} imported, {run.documentsExtracted} read by AI
          {run.clientsLinked > 0
            ? `, ${run.clientsLinked} matter${run.clientsLinked === 1 ? "" : "s"} added to the client list`
            : ""}
          {run.filesRemaining > 0
            ? `. ${run.filesRemaining} file${run.filesRemaining === 1 ? "" : "s"} left for the next run.`
            : "."}
        </p>
      )}
      {runQ.isError && (
        <p className="settings-error">Could not read the import status. Refresh to retry.</p>
      )}
      {start.isError && <p className="settings-error">{(start.error as Error).message}</p>}
    </section>
  );
}
